// extracted by mini-css-extract-plugin
export var asterisk = "LegalTerm-module--asterisk--502ff";
export var checked = "LegalTerm-module--checked--d7595";
export var formHelperText = "LegalTerm-module--formHelperText--cefc9";
export var label = "LegalTerm-module--label--64275";
export var labelCheckboxClass = "LegalTerm-module--labelCheckboxClass--4086b";
export var labelCheckboxClassStatement = "LegalTerm-module--labelCheckboxClassStatement--d791e";
export var legalTermContainer = "LegalTerm-module--legalTermContainer--b913a";
export var statementTitle = "LegalTerm-module--statementTitle--da46a";